// src/components/Experiment/JobAnalysisCard.js
import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Card, Badge, Spinner, Alert } from 'react-bootstrap';
import useImageWithAuth from '../../hooks/useImageWithAuth';

const JobAnalysisCard = ({ job, selected, status, calculateType, onSelectionChange, onCalculateTypeChange }) => {
  const [image, imageStatus, imageError] = useImageWithAuth('photo_processing', job.thumbnail);

  const handleCalculateTypeChange = (e) => {
    onCalculateTypeChange(e.target.value);
  };

  return (
    <Card className={`mb-2 ${!status?.ok ? 'border-danger' : ''}`}>
      <Card.Body className="p-2">
        <Form.Check
          type="checkbox"
          checked={selected}
          onChange={(e) => onSelectionChange(job.id, e.target.checked)}
          disabled={!status?.ok}
          className="d-inline-block me-2"
        />

        <div className="d-flex align-items-center">
          {job.thumbnail && (
            <div className="me-3">
              {imageStatus === 'loading' && (
                <Spinner animation="border" size="sm" />
              )}
              {imageStatus === 'loaded' && image && (
                <img
                  src={image.src}
                  alt={`Job ${job.id}`}
                  style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                  className="rounded"
                />
              )}
              {imageStatus === 'failed' && (
                <div className="text-danger small">Image failed</div>
              )}
            </div>
          )}

          <div className="flex-grow-1">
            <div className="d-flex justify-content-between align-items-start">
              <div>
                <h6 className="mb-1">Job #{job.id}</h6>
                {job.original_image_filename && (
                  <p className="text-muted small mb-1">{job.original_image_filename}</p>
                )}
                <div className="mb-1">
                  <Badge bg="secondary" className="me-1">
                    {job.grid_dimensions?.[0]}×{job.grid_dimensions?.[1]}
                  </Badge>
                  {job.crop_type_display && (
                    <Badge bg="info" className="me-1">
                      {job.crop_type_display}
                    </Badge>
                  )}
                  <Badge bg={status?.ok ? 'success' : 'danger'}>
                    {status?.ok ? 'OK' : 'Invalid'}
                  </Badge>
                </div>
                {!status?.ok && (
                  <small className="text-danger">{status?.reason}</small>
                )}
              </div>

              <div>
                <Form.Select
                    size="sm"
                    value={calculateType}
                    onChange={handleCalculateTypeChange}
                >
                  <option value="rgb">RGB</option>
                  <option value="intensity">Intensity</option>
                  <option value="rg_intensity">RG Intensity</option>
                  <option value="rb_intensity">RB Intensity</option>
                  <option value="gb_intensity">GB Intensity</option>
                  <option value="r">R</option>
                  <option value="g">G</option>
                  <option value="b">B</option>
                </Form.Select>
              </div>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default JobAnalysisCard;